import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import API from 'config/ApiConfig';
import { Mosaic } from 'react-loading-indicators';

export default function DetailSiswa() {
  const [siswaData, setSiswaData] = useState(null);
  const [tentors, setTentors] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const { siswaId } = useParams(); // Ambil siswaId dari useParams
  const API_BASE_URL = API.API_ADMIN;
  const JWT_TOKEN = localStorage.getItem('authToken');

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  useEffect(() => {
    const fetchSiswa = async () => {
      if (!siswaId) return;

      try {
        const response = await fetch(`${API_BASE_URL}/siswa/${siswaId}`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setSiswaData(data);

        // Asumsikan data.tentor_id sudah berisi data tentor lengkap
        if (data.tentor_id && Array.isArray(data.tentor_id)) {
          setTentors(data.tentor_id);
        }
      } catch (error) {
        console.error('Error fetching siswa details:', error);
        setFetchError('Failed to fetch siswa details.');
      }
    };

    fetchSiswa();
  }, [siswaId]);

  if (fetchError) {
    return <p className="text-red-500 text-xs">Tampaknya terjadi error, silahkan melakukan proses login kembali dengan logout terlebih dahulu</p>;
  }

  if (!siswaData) {
    return <div className="flex m-4 justify-center items-center w-screen"><Mosaic color="#1177bc" size="large" text="Loading.." textColor="" /></div>
  }

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Detail Siswa</h3>
      <div className="space-y-4 mb-2">
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Nama:</p>
          <p className="text-blueGray-600">{siswaData.nama}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2 ">
          <p className="font-semibold text-blueGray-600">Tempat Tanggal Lahir:</p>
          <p className="text-blueGray-600">{siswaData.ttl}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Nomor Telepon:</p>
          <p className="text-blueGray-600">{siswaData.telepon}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Nama Orang Tua:</p>
          <p className="text-blueGray-600">{siswaData.nama_orangtua}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Nama Sekolah:</p>
          <p className="text-blueGray-600">{siswaData.nama_sekolah}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Kelas:</p>
          <p className="text-blueGray-600">{siswaData.kelas}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Alamat:</p>
          <p className="text-blueGray-600">{siswaData.alamat}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Nama Tentor:</p>
          <ul>
            {tentors.length > 0 ? (
              tentors.map((tentor) => (
                <li key={tentor._id} className="text-blueGray-600">{tentor.nama}</li>
              ))
            ) : (
              <p className="text-blueGray-600">Belum Ada</p>
            )}
          </ul>
        </div>
        <div>
          <a href="/admin/siswa">
            <button
              type="button"
              className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            >
              Kembali
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}
